import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericService } from "app/commons/generic.service";
import { ParametroSessao } from "models/parametro-sessao";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ParametroSessaoService extends GenericService {
    private relativePath = 'v1/parametros-sessao';

    constructor(http: HttpClient) {
        super(http);
    }

    listarParametrosSessao(): Observable<Array<ParametroSessao>> {
        return this.getMethod(this.relativePath);
    }
}